<!--
 * @Author: HTT httishere0728@gmail.com
 * @Date: 2023-06-14 21:41:23
 * @LastEditors: Tina Huang
 * @LastEditTime: 2023-09-01 14:11:11
 * @FilePath: /notion-widgets-site/src/views/VIP.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE/
-->
<template>
  <div class="page-container container wrapper">
    <template v-if="component">
      <Plus size="small" v-bind="items[2]" :isExpired="isExpired" />
    </template>
    <template v-else>
      <h1 class="title center">
        👏 阿汪同学模版库永久会员
        <el-tag effect="dark" type="danger" size="small" v-show="!isExpired"
          >限时立减 <span class="countdown">{{ remain }}</span>
        </el-tag>
      </h1>
      <div class="block center">
        <el-row type="flex" class="row-bg" justify="space-around">
          <el-col :span="7" v-for="item in items" :key="item.type"
            ><div class="grid-content">
              <Plus v-bind="item" :isExpired="isExpired" /></div
          ></el-col>
        </el-row>
      </div>
      <div class="block">
        <el-row>
          <el-col :span="18" :offset="3"
            ><div class="grid-content bg-purple-light">
              <ol>
                <li>
                  购买永久会员后可享受<strong class="highlight"
                    >对应分类下的所有模版</strong
                  >
                </li>
                <li>对于已购买过的付费模版不做折现返还</li>
                <li>加入永久会员后不支持退换</li>
              </ol>
            </div></el-col
          >
        </el-row>
      </div>
    </template>
  </div>
</template>
<script>
import Plus from "../components/Plus.vue";

export default {
  props: ["component"],
  components: { Plus },
  data() {
    return {
      items_v: [
        {
          title: "FlowUS模版永久会员",
          type: "flowus",
          price: 99,
          off: 0, // 限时立减
          rights: [
            "全部FlowUs模版（含后续更新）",
            "限时分享组件",
            "模版定制服务享受9折优惠",
          ],
        },
        {
          title: "Notion模版永久会员",
          type: "notion",
          price: 159,
          off: 30, // 限时立减
          rights: [
            "全部Notion模版（含后续更新）",
            "限时分享组件",
            "模版定制服务享受9折优惠",
          ],
        },
        {
          title: "全部模版永久会员",
          type: "all",
          price: 249,
          off: 50, // 限时立减
          rights: [
            "全部FlowUs模版（含后续更新）",
            "全部Notion模版（含后续更新）",
            "限时分享组件",
            "模版定制服务享受8折优惠",
          ],
        },
      ],
      items_n: [
        {
          title: "FlowUS模版永久会员",
          type: "flowus",
          price: 99,
          off: 20, // 限时立减
          rights: [
            "全部FlowUs模版（含后续更新）",
            "限时分享组件",
            "模版定制服务享受9折优惠",
          ],
        },
        {
          title: "Notion模版永久会员",
          type: "notion",
          price: 129,
          off: 30, // 限时立减
          rights: [
            "全部Notion模版（含后续更新）",
            "限时分享组件",
            "模版定制服务享受9折优惠",
          ],
        },
        {
          title: "全部模版永久会员",
          type: "all",
          price: 199,
          off: 50, // 限时立减
          rights: [
            "全部FlowUs模版（含后续更新）",
            "全部Notion模版（含后续更新）",
            "限时分享组件",
            "模版定制服务享受8折优惠",
          ],
        },
      ],
      offExpired: new Date("2023/08/18 23:59:59"),
      remain: "",
      ct: null,
      items: [],
    };
  },
  computed: {
    isExpired() {
      const _cur = new Date().getTime();
      const expiration = this.offExpired.getTime();
      return _cur > expiration;
    },
  },
  mounted() {
    this.ct = setInterval(this.countdown, 1);
    console.log(this.isExpired);
    if (this.isExpired) {
      this.items = this.items_v;
    } else {
      this.items = this.items_n;
    }
  },
  methods: {
    countdown() {
      const _cur = new Date().getTime();
      const expiration = this.offExpired.getTime();
      const remain = expiration - _cur;
      if (remain > 0) {
        this.remain = this.formatTime(remain);
      } else {
        clearInterval(this.ct);
      }
    },
    formatTime(remain) {
      let _remain = remain;
      const d = parseInt(_remain / (24 * 60 * 60 * 1000));
      _remain = _remain % (24 * 60 * 60 * 1000);
      const h = parseInt(_remain / (60 * 60 * 1000));
      _remain = _remain % (60 * 60 * 1000);
      const m = parseInt(_remain / (60 * 1000));
      _remain = _remain % (60 * 1000);
      const s = parseInt(_remain / 1000);
      _remain = _remain % 1000;
      const ms = parseInt(_remain);
      return `${d}天 ${h}:${m}:${s}:${ms}`;
    },
  },
};
</script>

<style lang="less" scoped>
.center {
  text-align: center;
}
.block {
  width: 70vw;
  margin: 0 auto;
  line-height: 2;
  padding-bottom: 20px;
}
.title {
  line-height: 45px;
  .el-tag {
    vertical-align: middle;
  }
}
.highlight {
  color: #848fe0;
}
.grid-content {
  border-radius: 5px;
  margin-bottom: 10px;
}
.grid-button {
  display: inline-block;
  width: 100%;
}
.title-badge {
  display: block;
  margin: 0 auto;
}

.countdown {
  display: inline-block;
  width: 100px;
  text-align: left;
  padding-left: 10px;
}
</style>
